<template>
	<div class="distributor-settle-list">
		<div class="common-header-wrap">
			<mt-header :title="$t('distributor.title.settle_list')" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="common-btn btn" slot="right" @click="rightAction">{{ $t('general.setting') }}</div>
			</mt-header>
		</div>
		<div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
			<div v-if="bill_list && bill_list.length">
				<div style="display: flex; justify-content: space-around; align-items: center; padding: 1rem 2rem 0;">
					<img src="@/assets/image/member/wallet.png" style="width: 50px; padding-bottom: 10px;" />
					<div class="balance">{{ $t('distributor.settle.balance') }} <span style="color: #4caf50; font-weight: bold">{{ utils.currencyPrice(balance) }}</span></div>
					<div class="count" @click="settle()">{{ $t('distributor.settle.all_confirm') }}</div>
				</div>
				<div v-for="bill in bill_list" :key="bill.o2o_order_bill_id">
					<div class="settle-item">
						<div class="title">{{$moment.unix(bill.o2o_order_bill_start_time).format('LL')}}~{{$moment.unix(bill.o2o_order_bill_end_time).format('LL')}}</div>
						<div class="content">
							<div class="item">
								<div class="mt">{{ $t('distributor.settle.o2o_buy') }}</div>
								<div class="mc"><span class="strong">{{bill.o2o_order_bill_order_totals}}</span>{{ $t('distributor.general.unit_order') }}</div>
							</div>
							<div class="item">
								<div class="mt">{{ $t('distributor.settle.o2o_send') }}</div>
								<div class="mc"><span class="strong">{{bill.o2o_order_bill_errand_order_totals}}</span>{{ $t('distributor.general.unit_order') }}</div>
							</div>
							<div class="item">
								<div class="mt">{{ $t('distributor.settle.complaint') }}</div>
								<div class="mc"><span class="strong">{{bill.o2o_order_bill_complaint_totals}}</span>{{ $t('distributor.general.unit_order') }}</div>
							</div>
							<div class="item">
								<div class="mt">{{ $t('distributor.settle.income') }}</div>
								<div class="mc income"><span class="strong">{{bill.o2o_order_bill_income_totals}}</span>{{ $t('general.dollar') }}</div>
							</div>
							<div class="item">
								<div class="mt">{{ $t('distributor.settle.outlay') }}</div>
								<div class="mc outlay"><span class="strong">{{bill.o2o_order_bill_outlay_totals}}</span>{{ $t('general.dollar') }}</div>
							</div>
						</div>
						<div class="payment-account">
							<span></span>
							<mt-button v-if="bill.o2o_order_bill_state == OrderBillState.PENDING" @click="settle(bill.o2o_order_bill_id)" class="btn" type="default" size="small" plain>{{ $t('distributor.settle.confirm') }}</mt-button>
							<mt-button v-else-if="bill.o2o_order_bill_state == OrderBillState.COMPANY_CONFIRMED && bill.o2o_distributor_payment_type == SettleType.CASH" @click="paymentNote(bill.o2o_order_bill_id, bill.o2o_order_bill_result_totals)" class="btn" type="primary" size="small">{{ $t('distributor.settle.settle_confirmed') }}</mt-button>
							<mt-button v-else class="btn" type="default" size="small" disabled>{{bill.o2o_order_bill_state_text}}</mt-button>
						</div>
					</div>
				</div>
			</div>
			<empty-record v-else-if="bill_list && !bill_list.length"></empty-record>
		</div>
		<!--设置结算账号-->
		<mt-popup v-model="accountSetVisible" position="right" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header :title="$t('general.setting')" class="common-header">
					<mt-button slot="left" icon="back" @click="accountSetVisible=false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content" style="top: 4rem">
				<mt-field class="menu-item" :label="$t('distributor.settle.distributor_bank')" type="textarea" rows="4" v-model="paymentAccount" />
				<mt-button type="primary" @click='updatePaymentAccount' size="large">{{ $t('general.save') }}</mt-button>
			</div>
		</mt-popup>

		<mt-popup v-model="chooseTypeVisible" position="bottom" style="height: 10rem;">
			<div style="display: block; font-size: 0.8rem; width: 100%; text-align: center; margin: 8px 0;">{{ $t('distributor.settle.settle_types.title') }}</div>
			<mt-radio v-model="settleType" @input="setSettleType($event)" :options="settleTypeOptions"></mt-radio>
		</mt-popup>
	</div>
</template>

<script>

import { Toast, Indicator, MessageBox } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import Decimal from 'decimal.js'
import EmptyRecord from '../../../components/EmptyRecord'
import { updateUserPaymentAccount } from '../../../api/distributorUser'
import { getBillList, confirmBill, payByCode } from '../../../api/distributorBill'
import { OrderBillState } from '@/const/order'
import { SettleType } from '@/const/distributor'
export default {
	components: {
		EmptyRecord
	},
	name: 'DistributorSettleList',
	data () {
		return {
			paymentAccount: '',
			accountSetVisible: false,
			chooseTypeVisible: false,
			wrapperHeight: 0,
				params: { 'page': 0, 'per_page': 10 },
				loading: false, // 是否加载更多
				isMore: true, // 是否有更多
			bill_list: false,
			balance: 0,
			settleType: '',
			settleIds: [],
			OrderBillState: OrderBillState,
			SettleType: SettleType,
		}
	},

	mounted () {
		this.wrapperHeight = document.documentElement.clientHeight - 90
	},
	computed: {
		...mapState({
			user: state => state.distributor.info,
			config: state => state.config.config,
		}),
		settleTypeOptions() {
			return [{
				label: this.$t('distributor.settle.settle_types.account') + ': ' + this.paymentAccount,
				value: SettleType.ACCOUNT,
			}, {
				label: this.$t('distributor.settle.settle_types.cash'),
				value: SettleType.CASH,
			}]
		}
	},
	created: function () {
		this.paymentAccount = this.user.payment_account

	},
	methods: {
		...mapMutations({
			distributorEdit: 'distributorEdit'
		}),
		setSettleType(type) {
			console.log(type)
			this.chooseTypeVisible = false
			if (type === SettleType.ACCOUNT) {
				MessageBox({
					title: this.$t('distributor.settle.settle_account_title'),
					message: this.$t('distributor.settle.settle_account_note1') + '<br>' + this.$t('distributor.settle.settle_account_note2', [this.paymentAccount]),
					showCancelButton: true,
					closeOnClickModal: false,
				}).then((res) => {
					console.log(res)
					if (res == 'confirm')
						this.confirmBill(type)
					else
						this.settleType = ''
				})
			} else if (type === SettleType.CASH) {
				MessageBox({
					title: this.$t('distributor.settle.settle_cash_title'),
					message: this.$t('distributor.settle.settle_cash_note1') + '<br>' + this.$t('distributor.settle.settle_cash_note2', [this.config.o2o_settle_address]),
					confirmButtonText: this.$t('distributor.settle.settle_cash_confirm_button'),
					showCancelButton: true,
					closeOnClickModal: false,
				}).then((res) => {
					if (res == 'confirm')
						this.confirmBill(type)
					else
						this.settleType = ''
				})
			}
		},
		settle (bill_id) {
			if (!bill_id) {
				bill_id = this.bill_list.filter(item => item.o2o_order_bill_state === OrderBillState.PENDING).map(item => item.o2o_order_bill_id)
			}
			this.chooseTypeVisible = true
			this.settleIds = Array.isArray(bill_id)? bill_id : [bill_id]
		},
		confirmBill (type) {
			confirmBill(this.settleIds, type).then(res => {
				Toast(res.message)
				this.$router.go(0)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		updatePaymentAccount () {
			updateUserPaymentAccount(this.paymentAccount).then(res => {
				this.distributorEdit({ payment_account: this.paymentAccount })
				Toast(res.message)
				this.$router.go(0)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		rightAction () {
			this.accountSetVisible = true
		},
		loadMore () {
			this.loading = true
			this.params.page = ++this.params.page
			if (this.isMore) {
				this.loading = false
				this.getBillList(true)
			}
		},
		getBillList () {
			Indicator.open()
			getBillList(this.params, {}).then(res => {
				Indicator.close()
				if (res.result.hasmore) {
						this.isMore = true
				} else {
						this.isMore = false
				}

				let t_bill_list = res.result.bill_list

				if (t_bill_list) {
					if (!this.bill_list) {
						this.bill_list = t_bill_list
					} else {
						this.bill_list = this.bill_list.concat(t_bill_list)
					}
				}
				if (res.result.sum) {
					this.balance = res.result.sum
				}
			}).catch(function (error) {
				Indicator.close()
				Toast(error.message)
			})
		},
		paymentNote (bill_id, amount) {
			MessageBox.alert(
				this.$t('distributor.settle.payment_note_line1') + '<br>' +
					this.$t('distributor.settle.payment_note_line2', [this.config.o2o_settle_address]) + '<br>' +
					this.$t('distributor.settle.payment_note_line3', [this.utils.currencyPrice(amount)]),
				this.$t('distributor.settle.payment_note_title')
			).then(() => {
				MessageBox.prompt(this.$t('distributor.settle.payment_confirm_passowrd'), '').then(({ value, action }) => {
					console.log(value, action)
					Indicator.open()
					payByCode(bill_id, value)
						.then(res => {
							Indicator.close()
							Toast(res.message)
							this.$router.go(0)
						}).catch(err => {
							Indicator.close()
							Toast(err.message)
						})
				})
			})
		}
	}
}
</script>
<style  lang="scss" scoped>
	.common-header{
			.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
	}
	.distributor-settle-list {
		.payment-account{font-size:.7rem;color:#333;padding:.5rem 0;border-top:1px solid #eee;display:flex;
			span{flex:1;line-height:1.5;padding-right:.5rem}
			.btn{width:4rem}
		}
		.settle-item {
			background: #fff;
			margin-top: .5rem;
			border-top: 1px solid #eee;
			border-bottom: 1px solid #eee;
			padding: 0 .5rem;
			.title {
				font-size: .6rem;
				border-bottom: 1px solid #eee;
				color: #999;
				line-height: 2;
				.settle-state {
					float: right;
				}
				.state-check {
					color: orangered
				}
			}
			.content {
				padding: .5rem 0;
				display: flex;
				line-height: 1.5;
				.item {
					flex: 1;
					.mt {
						font-size: .6rem;
						color: #999
					}
					.mc {
						font-size: .6rem;
						color: #000;

						.strong {
							font-size: .7rem;
						}
					}
					.mc.income {
						color: #4caf50
					}
					.mc.outlay {
						color: #f31c47
					}
				}

			}
		}
	}
	.count {
		box-shadow: 0px 2px 4px #817e7e;
		background-color: #DD2C35;
		border-radius: 15px;
		font-size: 12px;
		padding: 8px 15px;
		color: white;
		letter-spacing: 1.1px;
	}
	.balance {
		font-family: '微軟正黑體';
		font-weight: bold;
		font-size: 18px;
	}
</style>
